module.exports = __webpack_public_path__ + "static/img/fa_user_svg.515b16c3.svg";